import { ViewSimpleSelect } from '../view/view-simple-select';

export class BoundingBoxSimpleSelect extends ViewSimpleSelect {
  private isCustomPrint;

  constructor(...args) {
    super(...args);

    //change selction mode
    document.removeEventListener('updateBoundingBoxMode', (e) => {
      console.log(e);
    });
    document.addEventListener('updateBoundingBoxMode', (e) => {
      if ((e as any).isCustomPrint) {
        this.isCustomPrint = true;
      } else {
        this.isCustomPrint = false;
      }
    });
  }

  async onMouseUp(state: any, e: MapMouseEvent): Promise<void> {
    if (state.boxSelectStart) {
      this.controller.mapInstance.dragPan.enable();
      state.boxElement.parentNode.removeChild(state.boxElement);
      state.boxElement = undefined;
      let bbox = [this.mouseEventPoint(state.boxSelectStart), this.mouseEventPoint(e.originalEvent)];
      let bounds = [
        state.boxSelectStartCoordinates.lng < e.lngLat.lng ? state.boxSelectStartCoordinates.lng : e.lngLat.lng,
        state.boxSelectStartCoordinates.lat < e.lngLat.lat ? state.boxSelectStartCoordinates.lat : e.lngLat.lat,
        state.boxSelectStartCoordinates.lng < e.lngLat.lng ? e.lngLat.lng : state.boxSelectStartCoordinates.lng,
        state.boxSelectStartCoordinates.lat < e.lngLat.lat ? e.lngLat.lat : state.boxSelectStartCoordinates.lat,
      ];

      if (this.isCustomPrint === true) {
        const event = new Event('handleCustomPicture');
        (event as any).bbox = bbox;
        (event as any).bounds = bounds;
        document.dispatchEvent(event);
        state.boxSelectStart = undefined;
      } else {
        this.controller.mapInstance.fire('draw.boxSelect', { bbox, bounds });
      }

    }
  }
}
